module.exports = __webpack_public_path__ + "img/start_button.6b2b5162.png";